module.exports = __webpack_public_path__ + "static/media/09B.68e5aa1c.png";